<template>
  <div class="header" id="topbackimg">
    <div class="wp">
      <div class="top bX">
        <div class="wel cur" @click="linkto"><i class="el-icon-arrow-left">返回慧涵官网</i></div>
        <div class="loginStatus">
          <div v-if="!userInfo" class="isLogined">
            <router-link :to="{path:'/login',query: { type: 1  }}">登录</router-link>
            <i class="cutline">|</i>
            <router-link :to="{path:'/login',query: { type: 2  }}">注册</router-link>
          </div>
          <div v-else class="unLogined">
            <span class="cur" @click="linktoMy">您好，{{userInfo.nickname}}</span>
            <i class="cutline">|</i>
            <span class="cursor-pointer" @click="exitLogin">退出</span>
          </div>
        </div>
      </div>
      <div class="loarea">
        <div class="logo">
          <img id="logoimg" src="@/assets/img/logo.png" alt="" class="tp" />
        </div>
      </div>
      <div class="nav">
        <div class="navul">
          <div class="navItem" v-for="(item, index) in navList" :key="index"
            :class="firstNavCur == item.url ? 'active' : ''">
            <span @click="toGoal1(item.url)" class="val">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from "jquery";
  import {
    getFormatDateWeek
  } from '@/utils/utils'
  
  import { logoutApi } from '@/http/api.js'
  export default {
    props: {
      navArray: Array
    },
    data() {
      return {
        keywords: "",
        firstNavCur: "",
        secondNavCur: "",
        navList: this.navArray,
        currentData: '',
      };
    },
    watch: {
      $route() {
        this.firstNavCur = this.$route.matched[0].path;
        this.secondNavCur = this.$route.matched[1] ?
          this.$route.matched[1].path : "";
      },
    },
    created() {
      this.getCurrentData();
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo
      },
    },
    methods: {
      linktoMy(){
        if(window.location.pathname === '/mine/myapply') return;
        window.open(window.location.origin+'/mine/myapply', '_self');
      },
      linkto(){
        window.open(document.getElementById('guanwang').innerHTML, '_blank');
      },
      // 退出登录、
      exitLogin() {
        logoutApi().then(res=>{
          this.$store.commit('EXIT_LOGIN');
          window.location.href=window.location.origin+"/login?type=1"
        })
      },
      toGoal1(_url) {
        this.$router.push(_url);
        sessionStorage.setItem('type', 'a');
      },
      toGoal2(_url, _type) {
        this.$router.push(_url);
        sessionStorage.setItem('type', _type);
      },
      // 获取顶部时间
      getCurrentData() {
        setTimeout(() => {
          this.currentData = getFormatDateWeek(new Date())
        }, 1000);
      }
    },
  };
</script>

<style lang="scss" scoped>
  .header {
    position: relative;
    z-index: 10;
    background-color: #EBF5F0;
    background-position: right bottom;
    background-repeat: no-repeat;
    border-bottom: 0.03rem solid #2F915D;
    padding-top: 0.16rem;
  }

  .top {
    .wel {
      flex: 1;
    }

    .loginStatus {
      width: 4rem;
      text-align: right;

      .cutline {
        margin: 0 1.2em;
      }

      .isLogined {}

      .unLogined {}
    }
  }

  .loarea {
    display: flex;
    align-items: center;
    margin-top: 30rpx;
  }

  .logo {
    font-size: 0;
    width: 60%; max-width: 566px; max-height: 58px;
    display: flex;
    align-items: center;
  }

  .logo .tp {
    height: .56rem;
  }

  .nav {
    overflow: hidden;
    margin-top: .56rem;
  }

  .navul {
    display: flex;
    position: relative;
    background-color: #fff
  }

  .navItem {
    width: 20%;
    display: block;
    cursor: pointer;
    position: relative;

    .val {
      font-size: 0.18rem;
      height: .68rem;
      line-height: .68rem;
      padding: 0 2em;
      color: #333;
      transition: .3s;
      display: block;
      position: relative;
      text-align: center;
      z-index: 1;
    }

    &::before {
      content: "";
      display: block;
      width: 1px;
      height: 20rpx;
      background-color: #DBDBDB;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    &:nth-last-child(1)::before {
      display: none;
    }

    &::after {
      content: "";
      display: block;
      width: 100%;
      height: 0;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #2F915D;
      transition: .3s;
    }

    &:hover .val,
    &.active .val {
      color: #fff !important;
    }

    &:hover::after,
    &.active::after {
      height: 100% !important;
    }
  }

  @media only screen and (max-width: 767px){
    .nav{margin-top:0.3rem}
    .navItem{
      .val{font-size: 0.24rem;}
    }
  }
</style>